module.exports = __webpack_public_path__ + "static/media/kai.dd3c02e0.png";